The type of event, i.e. CandidateApplicationCreated. This corresponds to the `Event.typeCode` field in the GraphQL schema.
